jQuery(window).ready(function(){

      $('.submenu-parent li').click(function(){
        var smenu = $(this).find(".collapsed").length;
        if (smenu > 0){
        	$(this).find(".collapsed").attr("style", "display:block");
        	$(this).find(".submenu-lowest").removeClass("collapsed");
        	$(this).find(".submenu-lowest").addClass("expanded");
        }else{
        	$(this).find(".expanded").attr("style", "display:none");
        	$(this).find(".submenu-lowest").removeClass("expanded");
        	$(this).find(".submenu-lowest").addClass("collapsed");
        }
      });
  
  
//    $('.submenu-parent li').click(function(){
//       $(".submenu-lowest").attr("style", "display:none");
//       if ($(this).find(".submenu-lowest").hasClass("expanded")){
//         $(this).find(".submenu-lowest").attr("style", "display:none").addClass("collapsed").removeClass("expaned");
//       }
//       if ($(this).find(".submenu-lowest").hasClass("collapsed")){
//         $(this).find(".submenu-lowest").attr("style", "display:block").addClass("expanded").removeClass("collapsed");
//       }
//       $(this).find(".submenu-lowest").attr("style", "display:block").addClass("expanded");
//          $(this).find(".submenu-lowest").toggle();
//    });
    
    
	/*
    var menu_length = $("ul.wsmenu-list li.gmclass").length;
    var megamenu_length = 0;
    var megasubmenu_length = 0;
    var submenu = 0;
    for (var i=0; i<=menu_length; i++){
      console.log('outer loop iteration i = '+i+'\n');
      megamenu_length = $("ul.wsmenu-list li div.megamenu").length;
      console.log('megamenu_length = '+megamenu_length+'\n');
      if (megamenu_length > 0){
        megasubmenu_length = $("ul.wsmenu-list li div.megamenu ul.wsmenu-sub-list li.mb20d").length;
        console.log('megasubmenu_length = '+megasubmenu_length+'\n');
        for (var j = 0; j<=megasubmenu_length; j++){
          console.log('inner for loop iteration j = '+j+'\n');
          submenu = $("ul.wsmenu-list li div.megamenu ul.wsmenu-sub-list li ul.submenu").length;
          console.log('submenu_length = '+submenu+'\n');
          if (submenu == 0){
            $(".wsmenu-sub-list").children("span.wsmenu-click02").css('display','none');
            console.log('icon readched\n');
          }
        }
      }
    } 
    
    */
});